import ReelsContainer from './ReelsContainer';
import EntryPoint from 'Engine/EntryPoint';
import ControllerBonusFeatures from '../slot/features/ControllerBonusFeatures';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../enums/eSounds';

export default class ContainerBonusReels extends ReelsContainer {
  constructor(...args) {
    super(...args);
  }

  init() {
    this._stopSoundPlayed = false;
    this._scatterSoundPlayed = false;
    this.ControllerReels = this.getChildByName('controllerReels');
    // this.updateReels();
  }

  addListeners() {
    this.ControllerReels.onAllReelsStopped = this.onAllReelsStopped.bind(this);
    this.ControllerReels.onHittingBar = this.onHitBar.bind(this);
    this.ControllerReels.onCycleAvailableSymbol = this.onCycleAvailableSymbol.bind(this);
    this.ControllerReels.onStart = this.blurSymbols.bind(this);
  }

  show() {
    super.show();
    this.updateReels();
    this.ControllerFeatures.onStart();
  }

  hide() {
    super.hide();
    this.ControllerFeatures.onEnd();
  }

  updateReels() {
    const bonusReels = EntryPoint.GameModel.bonusReels;
    const initialReels = bonusReels.flat();
    this.ControllerReels.reels.forEach((reel, i) => {
      // reel.symbols.forEach(symbol => this.onCycleAvailableSymbol(symbol));
      reel.symbols[this.ControllerReels.topSimbolsCount].changeSymbol(initialReels[i]);
    });
  }

  initReels() {
  }

  initFeaturesController(topContainer) {
    this.ControllerFeatures = new ControllerBonusFeatures({
      reelsContainer: this,
      controllerReels: this.ControllerReels,
      topContainer
    });
  }

  stop(data) {
    this.data = data;
    const config = this._getReelsStopConfig();
    Object.assign(this.ControllerReels, config);
    this.ControllerReels.stop(this.data);
  }

  onHitBar(reelIndex) {
    // this.ControllerReels.reels[reelIndex].symbols.forEach(symbol => symbol.startStopAnimation());
    this.ControllerFeatures.onReelHitBar(reelIndex);
    const symbol = this.ControllerReels.reels[reelIndex].symbols[this.ControllerReels.topSimbolsCount];
    if (symbol.id) {
      symbol.startStopAnimation();
      this.playStopSound();
    }
  }

  playStopSound() {
    if (!this._scatterSoundPlayed) {
      SoundManager.play(eSounds.EST_SCATTER_STOP.soundName, eSounds.EST_SCATTER_STOP.volume + 0.2 * Math.random(), false, eSounds.EST_SCATTER_STOP.group);
      this._scatterSoundPlayed = EntryPoint.GameSettings.quickStop;
    }
  }

  onAllReelsStopped() {
    this.ControllerFeatures.onAllReelsStopped();
    super.onAllReelsStopped();
  }

  blurSymbols() {
    for (let reel of this.ControllerReels.reels) {
      if (this.ControllerReels.excludedReels.includes(reel.id)) continue;
      reel.symbols.forEach(symbol => symbol.blur = true);
    }
  }

  onCycleAvailableSymbol(...args) {
    this.ControllerFeatures.onCycleAvailableSymbol(...args)
  }
}
